import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import Sidebar from '../../components/Blog/Sidebar';
import DataState from '../../components/DataState';
import { useCollections } from '../../lib/api/collections';
import { useSeo } from '../../lib/seo';

import { newsImages } from '../../data/images';

const BlogDetailsMain = () => {
  const { slug } = useParams();
  const content = useCollections('news');
  const found = content.news && content.news.find((n) => n.id === slug);
  useSeo(found ? { title: found.seoTitle || `${found.title} | SANASA Campus`, description: found.seoDescription || (found.article.paras[0] || '').slice(0, 160) } : null);
  if (content.loading || content.error) return <DataState state={content} />;
  const post = content.news.find((n) => n.id === slug);
  const article = post && post.article;
  if (!post || !article) return <Navigate to="/news" replace />;

  const pictures = newsImages(post);
  const shareUrl = encodeURIComponent(window.location.href);

  return (
    <main>
      <Breadcrumb title="News" subTitle="News" />

      <div className="postbox__area fix pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-xxl-8 col-xl-8 col-lg-8">
              <div className="postbox__details-wrapper">
                <article>
                  <div className="postbox__thumb mb-30 w-img">
                    <img src={pictures.main} alt="" />
                  </div>
                  <div className="postbox__details-title-box pb-40">
                    <div className="postbox__meta">
                      <span>
                        <i className="fa-solid fa-calendar-days"></i>
                        {post.date}
                      </span>
                      <span>
                        <i className="fa-regular fa-tag"></i>
                        {post.category}
                      </span>
                    </div>
                    <h4 className="postbox__title mb-20">{post.title}</h4>
                    {article.paras.map((para) => (
                      <p key={para}>{para}</p>
                    ))}
                  </div>
                  <div className="postbox__content pb-20">
                    <div className="postbox__content-img mb-40 d-flex justify-content-between">
                      <img className="mr-30" src={pictures.a} alt="" />
                      <img src={pictures.b} alt="" />
                    </div>
                    <div className="postbox__text">
                      <h4 className="postbox__details-title">
                        {article.heading}
                      </h4>
                      <p>{article.body}</p>
                    </div>
                  </div>
                  <div className="postbox__item text-center">
                    <i className="fas fa-quote-right"></i>
                    <p>{article.quote}</p>
                    <span>{post.author}</span>
                  </div>
                  <div className="postbox__details-share-wrapper">
                    <div className="row align-items-center">
                      <div className="col-xl-7 col-lg-7 col-md-7">
                        <div className="postbox__details-tag">
                          <span>Posted in:</span>
                          {article.tags.map((tag) => (
                            <a key={tag} href="#">
                              {tag}
                            </a>
                          ))}
                        </div>
                      </div>
                      <div className="col-xl-5 col-lg-5 col-md-5">
                        <div className="postbox__details-share text-lg-end">
                          <span>Share:</span>
                          <a
                            href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a
                            href={`https://wa.me/?text=${shareUrl}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa-brands fa-whatsapp"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-4">
              <Sidebar />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default BlogDetailsMain;
